import React from 'react';
import { GetStaticProps } from 'next';
import { withGlobalProvider } from 'providers/globalProvider';
import { Theme } from '@theme/base';
import { SectionContainer, SectionSeparator } from '@styles/layout';
import { storeWrapper } from '@state/store';
import { initializeApp } from '@state/initializeApp';
import { PageProps } from '@model/pages';
import { HelpCentreApi } from '@model/iceberg/service/help-centre';
import { Revalidate } from '@model/config/revalidate';
import { HelpCategoriesResponse } from '@model/iceberg/help-centre';
import { useI18NextContext } from '@components/hooks';
import { Head } from '@components/common/head';
import { NavBarContainer } from '@components/navigation';
import SearchTabsBar from '@components/search/SearchTabsBar';
import { HelpCentreBreadcrumb } from '@components/breadcrumbs/help-centre';
import { Footer } from '@components/footer';
import { HelpCentreSearchContainer, HelpCentreTileGroup } from '@components/help-centre';
import { TripTypes } from '@model/common';

export interface HelpPageProps extends PageProps {
  theme: Theme;
  categories: HelpCategoriesResponse;
}

const HelpPage = ({ categories, promoBannerTripType }: HelpPageProps) => {
  const t: any = useI18NextContext();

  return (
    <>
      <Head metaTitle={t('help-centre__title')} metaDescription={''} />
      <NavBarContainer promoBannerTripType={promoBannerTripType} renderSearch={<SearchTabsBar condensed />} />
      <HelpCentreSearchContainer />
      <HelpCentreBreadcrumb />
      <SectionContainer>
        <HelpCentreTileGroup categories={categories.data} />
      </SectionContainer>
      <SectionSeparator />
      <Footer />
    </>
  );
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async () => {
  const props = await initializeApp(store, async () => {
    const categories = await new HelpCentreApi().getCategories();

    return {
      categories,
      promoBannerTripType: TripTypes.ALL
    };
  });
  return {
    ...props,
    revalidate: Revalidate.HALF_HOUR
  };
});

export default withGlobalProvider(HelpPage);
